"use client";

import styled from "styled-components";

export const ParagraphLayoutWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.8rem;

  .article-detail-mobile-ui-true & {
    gap: 0.4rem;
  }

  @media only screen and (max-width: 768px) {
    gap: 0.4rem;
  }
`;
